export const START_TOUR = 'START_TOUR';

export function startTour(data) {
	return async dispatch => {
		dispatch({
			type: START_TOUR,
			data
		});
	};
};
